const mapping: Record<string, string> = {
  id: 'psd=>psd.Id',
  language: 'psd=>psd.Language',
  schemeId: 'psd=>psd.SchemeId',
}

export const mapSortPalmSchemeDataParam = (key: string) => mapping[key]
